import { Dimension } from './dimensions';

export type DimensionDeltas = Partial<Record<Dimension, number>>;

export type CoreEvent =
  | 'swipe_up_escape'
  | 'swipe_down_confront'
  | 'swipe_left_play_cool'
  | 'swipe_right_fix'
  | 'long_press_suppress'
  | 'double_tap_meme'
  | 'shake_spiral'
  | 'fast_fling_nope'
  | 'timed_hesitation';

export const primaryEventDeltas: Record<CoreEvent, DimensionDeltas> = {
  swipe_up_escape: { avoidance: 8, repairIntent: -3 },
  swipe_down_confront: { conflictHeat: 8, directness: 5 },
  swipe_left_play_cool: { socialControl: 8, directness: -3, avoidance: 3 },
  swipe_right_fix: { repairIntent: 8, boundaryFirmness: 4, socialControl: 3 },
  long_press_suppress: { socialControl: 5, avoidance: 4, emotionalVolatility: 2 },
  double_tap_meme: { memeDefense: 8, socialControl: 2, directness: -2 },
  shake_spiral: { emotionalVolatility: 8, conflictHeat: 3 },
  fast_fling_nope: { impulsiveness: 8, avoidance: 3, socialControl: -2 },
  timed_hesitation: { avoidance: 4, emotionalVolatility: 4, impulsiveness: -3 }
};

export const secondaryChoiceDeltas: Record<string, DimensionDeltas> = {
  set_boundary: { boundaryFirmness: 6, directness: 4, repairIntent: 1 },
  offer_solution: { repairIntent: 6, boundaryFirmness: 2, directness: 2 },
  cancel_cleanly: { boundaryFirmness: 6, repairIntent: 4, socialControl: 2 },
  leave_on_read: { avoidance: 5, emotionalVolatility: 2, repairIntent: -2 },
  fake_busy: { avoidance: 4, socialControl: 4, directness: -2 },
  ghost_then_return: { avoidance: 6, repairIntent: 2, impulsiveness: -1 },
  direct_callout: { directness: 6, conflictHeat: 3, boundaryFirmness: 5 },
  polite_venom: { conflictHeat: 4, socialControl: 3, memeDefense: 2 },
  type_delete: { socialControl: 5, emotionalVolatility: 4, avoidance: 3 },
  screenshot_to_friend: { memeDefense: 4, socialControl: 3, chaosAppetite: 2 },
  meme_reply: { memeDefense: 4, repairIntent: 2 },
  mute_chat: { avoidance: 4, boundaryFirmness: 2 },
  organize_group: { socialControl: 5, repairIntent: 3 },
  hard_exit: { boundaryFirmness: 5, avoidance: 3, impulsiveness: 3 },
  plot_twist: { chaosAppetite: 8, impulsiveness: 4, memeDefense: 2 }
};
